const PRODUCTION = 'https://australia-southeast1-upskillinstitute-au.cloudfunctions.net';
const BASE = process.env.REACT_APP_BOOKING_PILOT_API_BASE || PRODUCTION;
export const pilotEnrolmentId = () => new URLSearchParams(window.location.search).get('pilotEnrolmentId') || '';
export function pilotSubmission() {
  const enrolmentId = pilotEnrolmentId();
  if (!enrolmentId) return undefined;
  let session;
  try { session = JSON.parse(sessionStorage.getItem('upskill.bookingPilot.session') || 'null'); } catch (_) {}
  if (!session?.token) throw new Error('Return to the student pilot and log in again.');
  return { enrolmentId, token: session.token };
}
export async function pilotRequest(action, extra = {}) {
  const context = pilotSubmission();
  if (!context) return null;
  const response = await fetch(`${BASE}/bookingPilotStudent`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
    credentials: 'omit', cache: 'no-store', body: JSON.stringify({ action, ...extra, ...context }) });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Unable to connect this form to your student profile.');
  return result;
}
// Only a pilot submission may be redirected to a test API. Everyday EOI and
// declaration submissions always post to production, even in a build that sets
// REACT_APP_BOOKING_PILOT_API_BASE for pilot testing.
export const pilotFunctionUrl = name => `${pilotEnrolmentId() ? BASE : PRODUCTION}/${name}`;

// The submitted document already exists by the time this runs, so the link is
// retried on its own and never throws: a failed link must not be reported to the
// student as a failed submission, which would make them submit a duplicate.
export async function pilotAttach(action, extra = {}, attempts = 3) {
  let message = '';
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try { await pilotRequest(action, extra); return { linked: true, error: '' }; }
    catch (error) {
      message = error.message;
      if (attempt < attempts) await new Promise(resolve => setTimeout(resolve, 400 * attempt));
    }
  }
  return { linked: false, error: message || 'It could not be linked to your student profile.' };
}
export function isPilotContinuePath(path) {
  if (typeof path !== 'string' || !/^\/(?:trafficCourseFlow|trafficControl|trafficImplementation|qldEoi|declaration)?\?/.test(path)) return false;
  const parsed = new URL(path, 'https://pilot.invalid');
  if (parsed.origin !== 'https://pilot.invalid') return false;
  return parsed.pathname === '/trafficCourseFlow' ? /^[\w-]+$/.test(parsed.searchParams.get('sid') || '')
    : /^[\w-]+$/.test(parsed.searchParams.get('pilotEnrolmentId') || '');
}
